import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-ippayment-status',
  templateUrl: './ippayment-status.component.html',
  styleUrls: ['./ippayment-status.component.css']
})
export class IppaymentStatusComponent implements OnInit {
  private bamboraResponseCodeMappings: any[] = [];
  paymentStatus: string;
  damsApplicationId: string;
  receipt: string;
  emailSent: number;
  mailHref: string;

  constructor(private route: ActivatedRoute) {
    this.loadBamboraResponseCodeMappings();
  }

  loadBamboraResponseCodeMappings() {
    this.bamboraResponseCodeMappings.push({code: '-1', description: 'Successful'});
    this.bamboraResponseCodeMappings.push({code: '01', description: 'Refer Card Issuer'});
    this.bamboraResponseCodeMappings.push({code: '02', description: 'Special Conditions'});
    this.bamboraResponseCodeMappings.push({code: '03', description: 'Invalid Merchant'});
    this.bamboraResponseCodeMappings.push({code: '04', description: 'Pick Up Card'});
    this.bamboraResponseCodeMappings.push({code: '05', description: 'Do Not Honour'});
    this.bamboraResponseCodeMappings.push({code: '06', description: 'Error'});
    this.bamboraResponseCodeMappings.push({code: '07', description: 'Pick Up Card Special Condition'});
    this.bamboraResponseCodeMappings.push({code: '09', description: 'Request In Progress'});
    this.bamboraResponseCodeMappings.push({code: '12', description: 'Invalid Transaction'});
    this.bamboraResponseCodeMappings.push({code: '13', description: 'Invalid Amount'});
    this.bamboraResponseCodeMappings.push({code: '14', description: 'Invalid Card Number'});
    this.bamboraResponseCodeMappings.push({code: '15', description: 'No Such Issuer'});
    this.bamboraResponseCodeMappings.push({code: '17', description: 'Customer Cancellation'});
    this.bamboraResponseCodeMappings.push({code: '18', description: 'Customer Dispute'});
    this.bamboraResponseCodeMappings.push({code: '19', description: 'Re-Enter Transaction'});
    this.bamboraResponseCodeMappings.push({code: '20', description: 'Invalid Response'});
    this.bamboraResponseCodeMappings.push({code: '21', description: 'No Action Taken'});
    this.bamboraResponseCodeMappings.push({code: '22', description: 'Suspected Malfunction'});
    this.bamboraResponseCodeMappings.push({code: '23', description: 'Unacceptable Transaction Fee'});
    this.bamboraResponseCodeMappings.push({code: '24', description: 'File Update Not Supported By Receiver'});
    this.bamboraResponseCodeMappings.push({code: '25', description: 'Unable To Locate Record On File'});
    this.bamboraResponseCodeMappings.push({code: '26', description: 'Duplicate Update Record, Old Record Replaced'});
    this.bamboraResponseCodeMappings.push({code: '27', description: 'File Update Field Edit Error'});
    this.bamboraResponseCodeMappings.push({code: '28', description: 'File Update File Locked Out'});
    this.bamboraResponseCodeMappings.push({code: '29', description: 'File Update Not Successful, Contact Acquirer'});
    this.bamboraResponseCodeMappings.push({code: '30', description: 'Invalid Pin Block'});
    this.bamboraResponseCodeMappings.push({code: '31', description: 'Acquirer Not Supported By Switch'});
    this.bamboraResponseCodeMappings.push({code: '32', description: 'Completed Partially'});
    this.bamboraResponseCodeMappings.push({code: '33', description: 'Invalid Expiry Date'});
    this.bamboraResponseCodeMappings.push({code: '34', description: 'Suspected Fraud'});
    this.bamboraResponseCodeMappings.push({code: '35', description: 'Card Acceptor Contact Acquirer'});
    this.bamboraResponseCodeMappings.push({code: '36', description: 'Restricted Card'});
    this.bamboraResponseCodeMappings.push({code: '37', description: 'Contact Security – Acquirer'});
    this.bamboraResponseCodeMappings.push({code: '38', description: 'Pin Tries Exceeded – Card Retained'});
    this.bamboraResponseCodeMappings.push({code: '39', description: 'No Credit Account'});
    this.bamboraResponseCodeMappings.push({code: '40', description: 'Request Function Not Supported'});
    this.bamboraResponseCodeMappings.push({code: '41', description: 'Lost Card'});
    this.bamboraResponseCodeMappings.push({code: '42', description: 'No Universal Account/Closed Account'});
    this.bamboraResponseCodeMappings.push({code: '43', description: 'Stolen Card'});
    this.bamboraResponseCodeMappings.push({code: '44', description: 'No Investment Account'});
    this.bamboraResponseCodeMappings.push({code: '51', description: 'Insufficient Funds'});
    this.bamboraResponseCodeMappings.push({code: '52', description: 'No Account Of Type Requested'});
    this.bamboraResponseCodeMappings.push({code: '53', description: 'No Savings Account'});
    this.bamboraResponseCodeMappings.push({code: '54', description: 'Invalid Expiry Date'});
    this.bamboraResponseCodeMappings.push({code: '55', description: 'Invalid Pin'});
    this.bamboraResponseCodeMappings.push({code: '56', description: 'No Card Record/Card Not Found'});
    this.bamboraResponseCodeMappings.push({code: '57', description: 'Transaction Not Permitted To Cardholder'});
    this.bamboraResponseCodeMappings.push({code: '58', description: 'Transaction Not Permitted At Terminal'});
    this.bamboraResponseCodeMappings.push({code: '59', description: 'Suspected Fraud'});
    this.bamboraResponseCodeMappings.push({code: '60', description: 'Contact Terminal Acquirer'});
    this.bamboraResponseCodeMappings.push({code: '61', description: 'Amount Limit Exceeded'});
    this.bamboraResponseCodeMappings.push({code: '62', description: 'Restricted Card'});
    this.bamboraResponseCodeMappings.push({code: '63', description: 'Security Violation'});
    this.bamboraResponseCodeMappings.push({code: '64', description: 'Original Amount Incorrect'});
    this.bamboraResponseCodeMappings.push({code: '65', description: 'Exceeds Withdrawal Frequency Limit'});
    this.bamboraResponseCodeMappings.push({code: '66', description: 'Contact Security Acquirer'});
    this.bamboraResponseCodeMappings.push({code: '67', description: 'Suspected Counterfeit Card'});
    this.bamboraResponseCodeMappings.push({code: '68', description: 'Transaction Timed Out'});
    this.bamboraResponseCodeMappings.push({code: '75', description: 'Excessive Pin Tries'});
    this.bamboraResponseCodeMappings.push({code: '90', description: 'Settlement/Cutover In Process'});
    this.bamboraResponseCodeMappings.push({code: '91', description: 'Card Issuer Unavailable'});
    this.bamboraResponseCodeMappings.push({code: '92', description: 'Transaction Cannot Be Completed'});
    this.bamboraResponseCodeMappings.push({code: '93', description: 'Duplicate Transmission'});
    this.bamboraResponseCodeMappings.push({code: '94', description: 'Reconciliation, Cutover Or Checkpoint Error'});
    this.bamboraResponseCodeMappings.push({code: '95', description: 'System/Component Malfunction'});
    this.bamboraResponseCodeMappings.push({code: '96', description: 'System Malfunction'});
    this.bamboraResponseCodeMappings.push({code: '97', description: 'MAC Incorrect'});
    this.bamboraResponseCodeMappings.push({code: '98', description: 'No Communications Key Available For Use'});
    this.bamboraResponseCodeMappings.push({code: '99', description: 'Unknown Error'});
    this.bamboraResponseCodeMappings.push({code: '107', description: 'Invalid transaction Amount'});
    this.bamboraResponseCodeMappings.push({code: '110', description: 'Invalid credit card number'});
    this.bamboraResponseCodeMappings.push({code: '111', description: 'Invalid credit card expiry date'});
    this.bamboraResponseCodeMappings.push({code: '500', description: 'Batch Record Exception'});
    this.bamboraResponseCodeMappings.push({code: '501', description: 'IP Address Maximum Amount for Period'});
    this.bamboraResponseCodeMappings.push({code: '502', description: 'IP Address Maximum Count for Period'});
    this.bamboraResponseCodeMappings.push({code: '503', description: 'CustRef Maximum Amount for Single Payment'});
    this.bamboraResponseCodeMappings.push({code: '504', description: 'CustRef Maximum Amount For Period'});
    this.bamboraResponseCodeMappings.push({code: '505', description: 'CustRef Maximum Count For Period'});
    this.bamboraResponseCodeMappings.push({code: '506', description: 'CustNumber Maximum Amount for Single Payment'});
    this.bamboraResponseCodeMappings.push({code: '507', description: 'CustNumber Maximum Amount For Period'});
    this.bamboraResponseCodeMappings.push({code: '508', description: 'CustNumber Maximum Count For Period'});
    this.bamboraResponseCodeMappings.push({code: '509', description: 'User Defined Value Maximum Amount for Single Payment'});
    this.bamboraResponseCodeMappings.push({code: '510', description: 'User Defined Value Maximum Amount For Period'});
    this.bamboraResponseCodeMappings.push({code: '511', description: 'User Defined Value Maximum Count For Period'});
    this.bamboraResponseCodeMappings.push({code: '512', description: 'Single Credit Card Maximum Amount for Single Payment'});
    this.bamboraResponseCodeMappings.push({code: '513', description: 'Single Credit Card Maximum Amount for Period'});
    this.bamboraResponseCodeMappings.push({code: '514', description: 'Single Credit Card Maximum Count for Period'});
    this.bamboraResponseCodeMappings.push({code: '515', description: 'Credit Card Number List'});
    this.bamboraResponseCodeMappings.push({code: '516', description: 'Credit Card BIN Range'});
    this.bamboraResponseCodeMappings.push({code: '598', description: 'Insufficient details to perform risk management check'});
    this.bamboraResponseCodeMappings.push({code: '599', description: 'Exception when processing risk management check'});
    this.bamboraResponseCodeMappings.push({code: '600', description: 'CC Manually Refunded'});
    this.bamboraResponseCodeMappings.push({code: '700', description: 'Invalid Disbursement XML'});
    this.bamboraResponseCodeMappings.push({code: '701',
      description: 'Disbursement XML amount total does not match the transaction amount'});
    this.bamboraResponseCodeMappings.push({code: '702', description: 'Account number must be supplied for each disbursement'});
    this.bamboraResponseCodeMappings.push({code: '703',
      description: 'Account number supplied for disbursement does not exist or account is inactive'});
    this.bamboraResponseCodeMappings.push({code: '704', description: 'Account number supplied for disbursement appears two or more times'});
    this.bamboraResponseCodeMappings.push({code: '800', description: 'Cannot find matching transaction to VOID'});
    this.bamboraResponseCodeMappings.push({code: '801', description: 'Unable to contact acquirer'});
    this.bamboraResponseCodeMappings.push({code: '802', description: 'VOID Declined by acquirer'});
    this.bamboraResponseCodeMappings.push({code: '803', description: 'VOID after settlement'});
    this.bamboraResponseCodeMappings.push({code: '804', description: 'Transaction not approved'});
    this.bamboraResponseCodeMappings.push({code: '805', description: 'Transaction already voided'});
    this.bamboraResponseCodeMappings.push({code: '996', description: 'Transaction is pending approval'});
    this.bamboraResponseCodeMappings.push({code: '997', description: 'Remote Interface Exception'});
    this.bamboraResponseCodeMappings.push({code: '998', description: 'Transaction Payment Cancelled'});
    this.bamboraResponseCodeMappings.push({code: '999', description: 'Timeout when waiting for a response'});
  }

  GetBamboraResponseDescriptionByCode(code: string): string {
    const indexOfResponseCode = _.find(this.bamboraResponseCodeMappings, (item: any) => {
      return item.code === code;
    });

    if (!indexOfResponseCode) {
      return '';
    }

    return indexOfResponseCode.description;
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      const responseCodeDescription = this.GetBamboraResponseDescriptionByCode(params['status']);
      this.paymentStatus = responseCodeDescription === '' ? 'Unknown status' : responseCodeDescription;
      this.emailSent = params['emailSent'];

      if (params.hasOwnProperty('damsapplicationid')) {
        this.damsApplicationId = params['damsapplicationid'];
      }
      if (params.hasOwnProperty('receipt')) {
        this.receipt = params['receipt'];
      }
    });

    const mainFooter: any = document.getElementById('mainFooter');
    if (mainFooter) {
      mainFooter.style.display = 'none';
    }

    const bannerHeader: any = document.getElementById('bannerHeader');
    if (bannerHeader) {
      bannerHeader.style.display = 'none';
    }

    const logoHeader: any = document.getElementById('logo');
    if (logoHeader) {
      logoHeader.style.display = 'none';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/ippayment-status/ippayment-status.component.ts